import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorGetParamsIntegrationAuthOpenApiModel = OperatorApplicationApi.OperatorGetParamsIntegrationAuthOpenApiModel;



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "RequestTipButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, showFreeDialogForSite, site} = useTextareaComponent();


let integrations = computed(() => {
    return site.value.integrations.filter(integration => {
        return OperatorAccountStore.integrationPlatformDictionary.value[integration.platformId]?.isTip
    });
})

async function requestTip(integration: OperatorGetParamsIntegrationAuthOpenApiModel) {
    if (!showFreeDialogForSite()) {
        let p: OperatorApplicationApi.OperatorMessageRequestTipOpenApiModel = {
            username: client.value.username,
            platformId: integration.platformId,
            authPrimaryId: integration.authPrimaryId
        };
        let result = await (new OperatorApiRequest({
            url: "/message/requestTip",
            p
        })).send();
        result.showMessageOnError();
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_unref(integrations).length == 1)
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: "hand-holding-dollar",
        tooltip: _unref(__)('Предложить оставить чаевые'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (requestTip(_unref(integrations)[0])))
      }, null, 8, ["tooltip"]))
    : (_unref(integrations).length > 1)
      ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
          key: 1,
          icon: "hand-holding-dollar",
          tooltip: _unref(__)('Предложить оставить чаевые'),
          onCommand: _cache[1] || (_cache[1] = ($event: any) => (requestTip(_unref(integrations)[$event as any as number])))
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(integrations), (integration, index) => {
                  return (_openBlock(), _createBlock(_component_el_dropdown_item, { command: index }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(OperatorAccountStore).integrationPlatformDictionary.value[integration.platformId]?.descr) + ": " + _toDisplayString(integration.descr), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"]))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["tooltip"]))
      : _createCommentVNode("", true)
}
}

})